import { Injectable } from '@angular/core';
import * as moment from "moment";

@Injectable({
  providedIn: 'root'
})
export class AppService {

  constructor() { }

  getDateTimeFormat(date) {
    if (localStorage.getItem('isDateTimeFormat') == 'true') {
      return moment(date).format('dddd, MM/DD/YY, hh:mm A');
    } else {
      return moment(date).format('MMMM DD, YYYY, hh:mm A');
    }
  }

  getDateFormat(date) {
    if (localStorage.getItem('isDateTimeFormat') == 'true') {
      return moment(date).format('dddd, MM/DD/YY');
    } else {
      return moment(date).format('MMMM DD, YYYY');
    }
  }

  getTimeFormat(date) {
    if (localStorage.getItem('isDateTimeFormat') == 'true') {
      return moment(date, 'HH:MM').format('hh:mm A');
    } else {
      return moment(date, 'HH:MM').format('hh:mm A');
    }
  }

  getGroupsTimeFormat(date) {
    let time = moment(date, 'hh:mm A');
    if (localStorage.getItem('isDateTimeFormat') == 'true') {
      return moment(time, 'HH:MM').format('hh:mm A');
    } else {
      return moment(time, 'HH:MM').format('hh:mm A');
    }
  }

  toFixedWithoutRounding(num, fractionDigits) {
    if ((num > 0 && num < 0.000001) || (num < 0 && num > -0.000001)) {
      // HACK: below this js starts to turn numbers into exponential form like 1e-7.
      // This gives wrong results so we are just changing the original number to 0 here
      // as we don't need such small numbers anyway.
      num = 0;
    }
    const re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fractionDigits || -1) + '})?');
    return Number(num.toString().match(re)[0]).toFixed(fractionDigits);
  }

}
